// Generated by scripts/generate-i18n-resources.mjs. Do not edit.
export const defaultLocale = 'en';
export const localeResourceLoaders = {
	en: () => import('./en.json').then(({ default: resources }) => resources),
	ro: () => import('./ro.json').then(({ default: resources }) => resources),
	el: () => import('./el.json').then(({ default: resources }) => resources),
	it: () => import('./it.json').then(({ default: resources }) => resources),
	de: () => import('./de.json').then(({ default: resources }) => resources),
	fr: () => import('./fr.json').then(({ default: resources }) => resources),
	es: () => import('./es.json').then(({ default: resources }) => resources)
} as const;
export type GeneratedLocale = keyof typeof localeResourceLoaders;
